// Was 1.2. And then was 1.8. Now is 1.5 for simple 12 / 8 ratio.
export const STAGE_ASPECT_RATIO = 1.5
export const STAGE_WIDTH_DESKTOP_OVERFLOW_PERCENTAGE = 1.05

// Illustrator files are at 10x scale.
export const ILLUSTRATOR_SCALE_FACTOR = 0.1
